import React, { useState } from 'react'
import NavBar from './navBar'
import Footer from './Footer'
import security1 from "../../assets/security1.svg"
import security2 from "../../assets/security2.svg"
import security3 from "../../assets/security3.svg"
import security4 from "../../assets/security4.svg"
import security5 from "../../assets/security5.svg"
import security6 from "../../assets/security6.svg"
import Hovered1 from "../../assets/hoveredSec1.svg"
import Hovered2 from "../../assets/hoveredSec2.svg"
import Hovered3 from "../../assets/hoveredSec3.svg"
import Hovered4 from "../../assets/hoveredSec4.svg"
import Hovered5 from "../../assets/hoveredSec5.svg"
import Hovered6 from "../../assets/hoveredSec6.svg"

const SecruityPage = () => {

    const cards = [
        {
            image: security1,
            hoveredImg: Hovered1,
            title: "Data Encryption",
            desc: "All sensitive data, including personal information, resumes, and job applications, should be encrypted using SSL/TLS protocols both during transmission and while at rest to ensure data privacy."
        },
        {
            image: security2,
            hoveredImg: Hovered2,
            title: "Two-Factor Authentication",
            desc: "Enable 2FA for user accounts, particularly for recruiters and hiring managers, to add an additional layer of security. Users should confirm their identity through a second form before gaining access."
        },
        {
            image: security3,
            hoveredImg: Hovered3,
            title: "Role-Based Access Control",
            desc: "Limit access to sensitive data based on the user’s role (e.g., candidate, recruiter, hiring manager). Only authorized personnel should have access to job applications, resumes, and other personal information."
        },
        {
            image: security4,
            hoveredImg: Hovered4,
            title: "Regular Security Audits",
            desc: "Perform routine security audits and vulnerability assessments to identify potential security risks and take corrective action. Ensure compliance with industry standards and regulations."
        },
        {
            image: security5,
            hoveredImg: Hovered5,
            title: "Secure Resume Storage",
            desc: "Store candidate resumes and personal data in a secure, centralized database with restricted access. Backup data regularly and ensure it’s protected against potential threats or breaches."
        },
        {
            image: security6,
            hoveredImg: Hovered6,
            title: "User Data Privacy",
            desc: "Always inform users about the type of data being collected and how it will be used. Follow global data privacy regulations like GDPR or CCPA and ensure the rights of the users are respected."
        }
    ]

    const [isHovered, setIsHovered] = useState(false);
    return (
        <>
            <NavBar />
            <div className='latest-product-feature'>
                <div className='latest-product-container'>
                    <p className='latest-produt-url'>Home/Platform/Security</p>
                    <p className='latest-product-head'>
                        Security
                    </p>
                    <p className='latest-product-desc'>This Security Policy reiterates our commitment to protect all the information and assets ensuring an efficient, and secure working environment </p>
                </div>
            </div>
            <div className='latest-products-container'>
                <div className='latest-products'>
                    {
                        cards.map((card, index) => {
                            return (
                                <div
                                    key={index}
                                    className="security-card"
                                    onMouseEnter={() => setIsHovered(index)}
                                    onMouseLeave={() => setIsHovered(null)}
                                >
                                    <div 
                                    className={`security-circle ${isHovered === index ? "hovered-circle" : ""
                                            }`}
                                    >
                                        <img
                                            src={isHovered === index ? card.hoveredImg : card.image}
                                            alt={card.title}
                                        />
                                    </div>
                                    <p
                                        className={`security-card-head ${isHovered === index ? "hovered-title" : ""
                                            }`}
                                    >
                                        {card.title}
                                    </p>
                                    <p
                                        className={`security-card-desc ${isHovered === index ? "hovered-desc" : ""
                                            }`}
                                    >
                                        {card.desc}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <Footer />
        </>

    )
}

export default SecruityPage